<template>
  <a class="text-md ">
    Leilão imperdível dia 03/11 <campanha-icone />
  </a>
</template>

<script>
import CampanhaIcone from "@/components/marketing/components/CampanhaIcone"
export default {
  name: "CampanhaTitulo",
  components: {CampanhaIcone}
}
</script>
